import React from 'react';
import { Link } from 'react-router-dom';
import { openConsentSettings } from './consent';

const linkClass = 'text-mono-mute hover:text-white transition-colors';

export function LegalLinks({ className = '' }) {
  return (
    <div className={`flex flex-wrap gap-x-6 gap-y-2 text-xs font-body ${className}`} data-testid="legal-links">
      <Link to="/privacy" className={linkClass} data-testid="legal-link-privacy">Privacy</Link>
      <Link to="/terms" className={linkClass} data-testid="legal-link-terms">Terms</Link>
      <Link to="/refunds" className={linkClass} data-testid="legal-link-refunds">Refunds</Link>
      <button type="button" onClick={openConsentSettings} className={linkClass} data-testid="legal-link-cookies">
        Cookie settings
      </button>
    </div>
  );
}

export function LegalFooter() {
  return (
    <footer
      className="border-t border-mono-line"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="legal-footer"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-6">
        <LegalLinks />
      </div>
    </footer>
  );
}
